import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IAlertTemplate } from '../../interfaces/dtos/IAlertTemplate';
import IAlertCategory from '../../interfaces/states/IAlertCategory';

// There are only two AlterTemplateGroup set in back office
// POSManualAlerts and PeripheralDevice

const initialState: IAlertCategory[] = [
  {
    name: 'Cashier',
    alertGroupId: 'POSManualAlerts',
    selected: true,
    alerts: [],
  },
  {
    name: 'Device',
    alertGroupId: 'PeripheralDevice',
    selected: false,
    alerts: [],
  },
];

class AlertReducer extends ImmerReducer<IAlertCategory[]> {
  public async selectCategory(alertGroupId: string) {
    // Deselect all
    this.draftState.forEach((category): void => {
      category.selected = false;
    });

    // Find the one to select and select it
    const selectedCategory = this.draftState.find(
      (category): boolean => category.alertGroupId === alertGroupId,
    );
    if (selectedCategory) {
      selectedCategory.selected = true;
    }
  }

  public updateAlerts(alerts: IAlertTemplate[], alertGroupId: string) {
    const selectedCategory = this.draftState.find(
      (category): boolean => category.alertGroupId === alertGroupId,
    );
    if (selectedCategory) {
      selectedCategory.alerts = alerts;
    }
  }
}

export const AlertActions = createActionCreators(AlertReducer);
export const AlertReducerFunction = createReducerFunction(AlertReducer, initialState);
